import api from "./api";

const customerService = {
  list: async () => {
    const res = await api.get("/api/admin/customers");
    return res.data;
  },
  get: async (id) => {
    const res = await api.get(`/api/admin/customers/${id}`);
    return res.data.data || res.data;
  },
  toggleStatus: async (id, is_active) => {
    const res = await api.patch(`/api/admin/customers/${id}/status`, { is_active });
    return res.data;
  },
};

export default customerService;

